import { Component, Inject, OnInit } from '@angular/core';
import { SafetyInductionService } from '../../services/safety-induction.service';
import { AddQuestionAnsVM, AnswerListVM, InductionQuestionsVM } from '../setup-induction-question';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface DialogData {
  Question: InductionQuestionsVM;
}
@Component({
  selector: 'app-answer-setup-induction-question',
  templateUrl: './answer-setup-induction-question.component.html',
  styleUrls: ['./answer-setup-induction-question.component.css']
})
export class AnswerSetupInductionQuestionComponent implements OnInit {
  Question: InductionQuestionsVM;
  constructor(
    public dialogRef: MatDialogRef<AnswerSetupInductionQuestionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _inductionService: SafetyInductionService,
  ) { }

  selectedTFAnswer: number;
  AnswerName: string;
  MultipleChoiceTF: AnswerListVM[];
  MultipleSelection: AnswerListVM[];
  AnswerNumber:number=1;
  AnswerNameMS:string;
  showError:boolean=false;

  ansersTF: [
    {
      Id: -1,
      name: "-select Answer"
    },
    {
      Id: 0,
      name: "False"
    },
    {
      Id: 1,
      name: "True"
    }
  ]

  ngOnInit() {
    this.Question = this.data.Question

    this._inductionService.GetAnswerListForQuestionId(this.data.Question.Id).subscribe(res=>{
      console.log('GetAnswerListForQuestionId',res)
      if(res.m_Item2){
        if(this.data.Question.QuestionTypeId == 1){
          if(res.m_Item2[0].correct){
            this.selectedTFAnswer = 0
          }else if(res.m_Item2[1].correct){
            this.selectedTFAnswer = 1
          }else{

          }
          
        }else if(this.data.Question.QuestionTypeId == 2){
          let arr =[]
          
          res.m_Item2.map(m=>{
            let obj =new AnswerListVM();
            obj.QuestionName = m.answer;
            obj.correct = m.correct;
            arr.push(obj)
          })

          this.MultipleChoiceTF = arr
        }else if(this.data.Question.QuestionTypeId == 3){
          let arr =[]
          res.m_Item2.map(m=>{
            let obj =new AnswerListVM();
            obj.QuestionName = m.answer;
            obj.correct = m.correct;
            arr.push(obj)
          })

          this.MultipleSelection = arr
        }
      }
    })

    if(this.data.Question.QuestionTypeId ==1){

    }

  }
  DialogClose() {
    this.dialogRef.close(false)
  }

  changeFTAnser(id) {

  }

  AddMultipleSelection(){
    if (this.MultipleSelection && this.MultipleSelection.length > 0) {
      let _ans = this.MultipleSelection.find(f => f.QuestionName == this.AnswerNameMS)

      if (_ans) {
        return
      }
    }


    let ans = new AnswerListVM();
    ans.QuestionName = this.AnswerNameMS;

    let arr = this.MultipleSelection ? this.MultipleSelection:[];
    arr.push(ans)

    this.MultipleSelection = arr
    console.log("MultipleSelection", this.MultipleSelection)
    this.AnswerNameMS = ""
  }

  AddMultipleChoice() {
    if (this.MultipleChoiceTF && this.MultipleChoiceTF.length > 0) {
      let _ans = this.MultipleChoiceTF.find(f => f.QuestionName == this.AnswerName)

      if (_ans) {
        return
      }
    }


    let ans = new AnswerListVM();
    ans.QuestionName = this.AnswerName;

    let arr = this.MultipleChoiceTF ? this.MultipleChoiceTF:[];
    arr.push(ans)

    this.MultipleChoiceTF = arr
    console.log("MultipleChoiceTF", this.MultipleChoiceTF)
    this.AnswerName = ""
  }

  removeMSAnswer(ans) {
    let arr = this.MultipleSelection.filter(f => f.QuestionName != ans.QuestionName)
    this.MultipleSelection = arr
  }

  removeMCAnswer(ans) {
    let arr = this.MultipleChoiceTF.filter(f => f.QuestionName != ans.QuestionName)
    this.MultipleChoiceTF = arr
  }

  AnswerCheckMC(ans) {
    let arr = this.MultipleChoiceTF
    arr.map(f => {
      if (f.QuestionName == ans.QuestionName) {

        f.correct = f.correct == true ? false : true
      }
    })

    this.MultipleChoiceTF = arr

  }

  AnswerCheckMS(ans) {
    let arr = this.MultipleSelection
    arr.map(f => {
      if (f.QuestionName == ans.QuestionName) {

        f.correct = f.correct == true ? false : true
      }
    })

    this.MultipleSelection = arr

  }

  onSubmit() {
    let AnswerList = []
    let AnswerTrue = -1
    let AnswerCount = 0;
    if (this.data.Question.QuestionTypeId == 1) {
      AnswerTrue = this.selectedTFAnswer;
    } else if (this.data.Question.QuestionTypeId == 2) {
      
      this.MultipleChoiceTF.map(m=>{
        let ans = new AnswerListVM();
        ans.answer = m.QuestionName
        ans.correct = m.correct
        AnswerList.push(ans)
      })


    } else if (this.data.Question.QuestionTypeId == 3) {
      AnswerCount = this.AnswerNumber

      let checkedAnswers = this.MultipleSelection.filter(m=>m.correct)
      
      if(checkedAnswers.length <= 0 || this.AnswerNumber <=0){
        this.showError = true
        return
      }

     
      this.MultipleSelection.map(m=>{
        let ans = new AnswerListVM();
        ans.answer = m.QuestionName
        ans.correct = m.correct
        AnswerList.push(ans)
      })


      
    }

    

    let params = new AddQuestionAnsVM();

    params.AnswerList = AnswerList;
    params.QId = Number(this.data.Question.Id);
    params.AnswerTrue = AnswerTrue;
    params.QType = this.data.Question.QuestionTypeId;
    params.AnswerCount = AnswerCount;


    //create new category
    this._inductionService.SaveAnswerForQuestion(params).subscribe(res => {
      console.log("SaveAnswerForQuestion", res)
      if (res) {
        this.dialogRef.close(true);
      }
      // this.dialogRef.close();

    })

  }
}
